<template>
  <div id="app" :class="[{ 'no-nav': isInfoCollectorFromH5 }]">
    <navi v-if="$route.meta.showNav && !isInfoCollectorFromH5" ref="nav1" class="nav"></navi>
    <keep-alive>
      <router-view class="viewContent" @loginDone="loginDone" @shuaxinApp="shuaxinApp" v-if="$route.meta.keepAlive"
        @notify="notify"></router-view>
    </keep-alive>
    <router-view class="viewContent" @loginDone="loginDone" @shuaxinApp="shuaxinApp"
      v-if="!$route.meta.keepAlive"></router-view>
    <el-drawer id="chongGou" direction="rtl" :wrapperClosable="false" :visible.sync="chongGou" close-on-press-escape
      :with-header="false" :size="this.drawerWidth" @closed="closeDialog">
      <reconstructionItem :chongGou="this.chongGou" :chongGouItem="this.chongGouItem" @shuaxinApp="shuaxinApp"
        @drawer="drawer" @closeDrawer="closeDrawer"></reconstructionItem>
    </el-drawer>

    <!-- 根据路由显示需求按钮 -->
    <div v-if="showRequirementButton" class="requirement-button-container">
      <el-button class="requirement-button" @click="handleRequirement">
        <div class="el-icon-chat-square" style="font-size: 22px;"></div>
        <div>提建议</div>
      </el-button>
    </div>
  </div>
</template>

<script>
import navi from './components/navi.vue'
import webFooter from './components/webFooter.vue'
import reconstructionItem from '@/components/allPage/reconstructionItem'
import { matchMedia } from '@/utils/DomTool.js'

export default {
  name: 'app',

  components: {
    reconstructionItem,
    navi,
    webFooter
  },

  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      drawerWidth: '',
      chongGouItem: {},
      chongGou: false,
      userName: '',
      windowError: [],
      addEvent: [],
      errorCaptured: [],
      errorHandler: [],
      isInfoCollectorFromH5: false
    }
  },
  computed: {
    showRequirementButton () {
      return this.$route.path.startsWith('/whiteList/') && this.$route.path !== '/whiteList/submitFeedback' &&
        this.$route.query.chat_id !== undefined && this.$route.query.u !== undefined
    }
  },
  methods: {
    shuaxinApp (value, item) {
      if (value === 'shuaxinRefactor') {
        this.chongGou = false
      } else if (value === 'addTag') {
        this.chongGou = false
        this.bus.$emit('shuaxin', 'addTag', item)
        this.$router.push({
          path: '/dailyBackFour'
        })
      } else if (value === 'chongGou') {
        this.getHeight()
        this.bus.$emit('shuaxin', 'chongGouOpen')
        this.chongGou = true
      } else if (value === 'chongGouChuanzhi') {
        this.getHeight()
        this.chongGouItem = JSON.parse(item)
        this.chongGou = true
      } else if (value === 'chongGouClose') {
        this.closeDialog()
      } else if (value === 'getLableName') {
        this.bus.$emit('shuaxin', 'getLableName')
      }
    },
    closeDrawer (value) {
      this.chongGouItem = {}
      this.closeDialog()
    },
    closeDialog () {
      this.chongGou = false
      this.bus.$emit('shuaxin', 'chongGouClose')
    },
    getHeight () {
      var windowWidth = window.innerWidth - 60
      this.drawerWidth = windowWidth + 'px'
    },
    drawer (value) {
      this.drawerWidth = value
    },
    loginDone () {
      var l = localStorage.getItem('userName')
      var url = window.location.href // 获取当前页面的url
      if (l !== null) {
        this.userName = l
        if (this.userName === 'guanzhao') {
          if (url.indexOf('?') !== -1) { // 判断是否存在参数
            url = url.replace(/(\?|#)[^'"]*/, '') // 去除参数
            window.location.href = url + '#/research'
          }
          return
        } else {
          this.$router.push({ name: 'home' })
        }
      }
      if (url.indexOf('?') !== -1) { // 判断是否存在参数
        url = url.replace(/(\?|#)[^'"]*/, '') // 去除参数
        window.location.href = url
      } else {
        window.location.reload()
      }
    },
    notify (value, text) {
      if (value === 'success') {
        this.$notify.success({
          title: '提示',
          message: text,
          duration: 0
        })
      } else {
        this.$notify.error({
          title: '提示',
          message: text,
          duration: 0
        })
      }
    },
    getDate () {
      const myDate = new Date()
      const year = myDate.getFullYear()
      const month = myDate.getMonth() + 1
      const date = myDate.getDate()
      const h = myDate.getHours()
      const m = myDate.getMinutes()
      const s = myDate.getSeconds()
      var time =
        year.toString() + '-' +
        this.convert(month).toString() + '-' +
        this.convert(date).toString() +
        ' ' +
        this.convert(h) +
        ':' +
        this.convert(m) +
        ':' +
        this.convert(s)
      return time
    },
    convert (val) {
      return val < 10 ? '0' + val : val
    },
    takeError (item, key) {
      if (!Array.isArray(this[key])) {
        this[key] = []
      }
      var time = this.getDate()
      this[key].unshift(item)
      this[key][0].time = time
      if (this[key].length > 20) {
        this[key].splice(this[key].length - 1, 1)
      }
      this.localForage.setItem(key, this[key])
    },

    // 判断当前是 客户端 还是 移动端
    matchMediaFn () {
      const _currentType = matchMedia()
      this.$store.commit('updateMatchMedia', _currentType)
    },

    // 响应化，获取当前的适配标识
    checkScreenSize () {
      const screenWidth = window.innerWidth
      let tag = 'xl'

      if (screenWidth <= 767.98) {
        tag = 'xs'
      } else if (screenWidth >= 768 && screenWidth <= 991.98) {
        tag = 'sm'
      } else if (screenWidth >= 992 && screenWidth <= 1199.98) {
        tag = 'md'
      } else if (screenWidth >= 1200 && screenWidth <= 1919.98) {
        tag = 'lg'
      } else if (screenWidth >= 1920) {
        tag = 'xl'
      }

      this.$store.commit('updateScreenSize', tag)
      return tag
    },
    changeSize () {
      this.matchMediaFn()
      this.checkScreenSize()
    },

    handleRequirement () {
      this.$router.push({
        path: '/whiteList/submitFeedback',
        query: { chat_id: this.$route.query.chat_id, u: this.$route.query.u }
      })
    }
  },

  watch: {
    '$route' (val) {
      this.isInfoCollectorFromH5 = val.path.startsWith('/infoCollector') && val.query && val.query.fromPage === 'h5' // 移动端跳转至信息收集器页面
    }
  },

  mounted () {
    var _this = this
    document.onkeydown = function (event) {
      let key = window.event.keyCode
      if (key === 112) {
        window.event.preventDefault()
        _this.shuaxinApp('chongGou')
      }
    }
    this.bus.$on('shuaxinApp', (value, item) => {
      _this.shuaxinApp(value, item)
    })
    this.localForage.getItem('windowError').then(function (value) {
      if (value) {
        _this.windowError = value
      }
    })
    this.localForage.getItem('addEvent').then(function (value) {
      if (value) {
        _this.addEvent = value
      }
    })
    this.localForage.getItem('errorHandler').then(function (value) {
      if (value) {
        _this.errorHandler = value
      }
    })
    this.localForage.getItem('errorCaptured').then(function (value) {
      if (value) {
        _this.errorCaptured = value
      }
    })
    window.onerror = function (msg, source, line, column, err) {
      // console.log('window.onerror---->', msg, source, line, column, err)
      _this.takeError({ msg: msg, source: source }, 'windowError')
    }
    window.addEventListener('unhandledrejection', event => {
      // console.log('监听Promise unhandledrejection', event.reason)
      _this.takeError(event.reason, 'addEvent')
    })

    this.matchMediaFn()
    this.checkScreenSize()
    // 监听页面窗口变化
    window.addEventListener('resize', this.changeSize)
  }
}
</script>

<style>
@import url(./style/scrutinizeEle.css);
@import url(./style/flex.css);
@import url(./style/backGauge.css);
@import url(./style/font.css);
@import url(./assets/iconfont/iconfont.css);

/* @import url(./style/button.css); */
.nav {
  position: fixed;
  /* 绝对定位，fixed是相对于浏览器窗口定位。 */
  top: 0;
  /* 距离窗口顶部距离 */
  left: 0;
  /* 距离窗口左边的距离 */
  width: 100%;
  /* 宽度设置为100% */
  /* height:40px; 高度 */
  z-index: 999;
  /* 层叠顺序，数值越大就越高。页面滚动的时候就不会被其他内容所遮挡。 */
}

.viewContent {
  margin-top: 70px !important;
}

#app {
  display: flex;
  flex-direction: column;
  height: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 0px; */
  /* min-width: 1300px; */
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.cardWhite {
  background: white;
  margin-bottom: 5px;
  color: black;
  font-weight: bold;
  font-size: 15px;
}

#nprogress .bar {
  background: #c4181f !important;
}

#nprogress .spinner-icon {
  border-top-color: #c4181f !important;
  border-left-color: #c4181f !important;
}

/* 对于宽度大于等于 769px 的设备，我们认为它是桌面端  */
@media (min-width: 769px) {

  /* 电脑端隐藏元素 */
  .pc-hidden {
    display: none !important;
  }
}

/* 对于宽度小于 768px 的设备，我们认为它是手机移动端 */
@media (max-width: 768px) {

  /* 手机移动端隐藏元素 */
  .mobile-hidden {
    display: none !important;
  }

  /* .viewContent {
      margin-top: 112px !important;
    } */
}

.no-nav .viewContent {
  margin-top: 0px !important;
}
</style>

<style scoped>
.requirement-button-container {
  position: fixed;
  bottom: 60px;
  z-index: 1000;
  max-width: 1000px;
  width: 100%;
  transform: translateX(-50%);
  left: 50%;
  display: flex;
  justify-content: flex-end;
}

.requirement-button {
  padding: 4px;
  font-size: 12px;
  line-height: 1.4;
  width: 46px;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue